import React, {useState, useEffect} from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Link from '@material-ui/core/Link'
// import Icon from '@material-ui/core/Icon'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import AddCircleIcon from '@material-ui/icons/AddCircle'

import Api from 'utils/Api'
import useFlash from 'modules/useFlash'
import {Wrapper} from 'components/molecules/Wrap'

import TableCell from '@material-ui/core/TableCell';
import ButtonDestroy from 'components/atoms/ButtonDestroy'
import newRowsPager from 'components/organisms/newRowsPager'

export default (props) => {
  const {handleApiError} = useFlash()
  const [loading, setLoading] = useState(true)
  useEffect(()=>{
    setLoading(true)
  }, [])


  const itemPager = newRowsPager({
    headers: ['id', 'ルール種別', '条件', 'リダイレクト先', 'status'],
    onPage: ({offset, limit, updateRows}) => {
      const params = {
        query: {offset, limit}
      }
      setLoading(true)
      Api.fetchAuth(`/redirect_rules`, params).then(r=>r.json()).then(response=>{
        updateRows(response.data, response.total)
        setLoading(false)
      }).catch(handleApiError)
    },
    rowComponent: ({row, removeRowById}) => (
      <React.Fragment>
        <ListItem {...row} />
        <TableCell>
          <ButtonDestroy resource_key={`redirect_rules`} resource={row} removeRowById={removeRowById} />
          {/*<ResourceStatusButton 
            resource_key={`redirect_rules`}
            resource={row} 
            updateRowById={updateRowById} />*/}
        </TableCell>
      </React.Fragment>
    )
  })
  
  return (
    <Wrapper>
      <Typography variant="h6" gutterBottom>
        <Grid container direction="row" justify="space-between">
          <Grid item>リダイレクト 一覧</Grid>
          <Grid item>
            <Button href={`/site/redirect_rules/new`} variant="contained" color="default"
              size="small" startIcon={<AddCircleIcon />}>
              New
            </Button>
          </Grid>
        </Grid>
      </Typography>
      
      {loading && <CircularProgress size={20} />}
      {itemPager.render}
    </Wrapper>
  )
}

const ListItem = (row) => (
  <React.Fragment>
    <TableCell>
      <Link href={`/site/redirect_rules/${row.id}`} color="inherit">
        <Typography variant="body2">{row.id}</Typography>
      </Link>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{row.condition_kind}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{Object.values(row.condition).join(' / ')}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{row.redirect_to}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2">{row.status}</Typography>
    </TableCell>
  </React.Fragment>
)

const useStyles1 = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
